module.exports = "/_next/static/images/483d2ca0653bf9aeeb31d146f4585a87-blog4-lg.png";